import { makeStyles } from '~/UIKit/Style';
import {
  GRAY_TABLE_TITLE,
  TABLE_HEAD_BORDER,
  PRIMARY_BLUE,
  TEXT_SUBHEADER,
  WHITE,
  GRAY_DISABLED,
  RED_USC,
} from '~/Constants/Colors.constants';
import {
  FONT_SIZE_SMALL,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_SMALLISH,
  FONT_SIZE_MEDIUM_CONFUSED,
} from '~/Constants/UI.constants';
import { OPTIONS_MENU_SHADOW } from '~/Constants/CSS.constants';

export const useStyles = makeStyles((theme) => ({
  tableContainer: {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  tableHead: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'table-header-group',
    },
  },
  tableCell: {
    borderBottom: `1px solid ${TABLE_HEAD_BORDER}`,
    color: `${GRAY_TABLE_TITLE}`,
    fontSize: FONT_SIZE_SMALL,
    fontWeight: '300',
    lineHeight: '16px',
  },
  tableCellProperties: {
    padding: '6px 16px',
    lineHeight: '16px',
  },
  name: {
    [theme.breakpoints.up('md')]: {
      marginBottom: 'initial',
    },
    marginBottom: theme.spacing(0.5),
    fontSize: FONT_SIZE_MEDIUM,
    fontWeight: 'bold',
  },
  tableCellName: {
    [theme.breakpoints.up('md')]: {
      padding: 'initial',
    },
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(2),
  },
  address: {
    fontSize: FONT_SIZE_SMALLISH,
  },
  tableCellAddress: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'table-cell',
    },
  },
  addressCellResponsive: {
    color: `${TEXT_SUBHEADER}`,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  tableCellStatus: {
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
    },
    display: 'flex',
    justifyContent: 'flex-end',
  },
  tableCellOptions: {
    [theme.breakpoints.up('md')]: {
      display: 'initial',
    },
    display: 'flex',
  },
  statusResponsive: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  emptyState: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchBarWrapper: {
    width: '100%',
    padding: '0 16px',
    [theme.breakpoints.up('md')]: {
      width: '295px',
      padding: '0',
    },
  },
  searchBar: {
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(5),
    },
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #adadb880',
    borderRadius: '25px',
    color: '#adadb880',
    fontSize: FONT_SIZE_MEDIUM_CONFUSED,
    height: '28px',
    padding: '5px',
  },
  searchInput: {
    '&::placeholder': {
      color: '#adadb880',
    },
    width: '100%',
    fontSize: FONT_SIZE_SMALL,
    lineHeight: '16px',
    padding: '0 5px',
    borderRadius: '25px',
    borderColor: '#adadb880',
    color: '#adadb8',
    border: 'none',
    outline: 'none',
  },
  switchRoot: {
    width: 42,
    height: 22,
    padding: 0,
    margin: theme.spacing(1.5),
    marginLeft: 0,
    marginRight: 0,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: `${PRIMARY_BLUE}`,
      '& + $track': {
        backgroundColor: `${PRIMARY_BLUE}`,
        opacity: '1',
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: `${PRIMARY_BLUE}`,
      border: `6px solid ${WHITE}`,
    },
  },
  thumb: {
    width: 20,
    height: 20,
    background: `${WHITE}`,
  },
  track: {
    borderRadius: 13,
    border: `1px solid ${GRAY_DISABLED}`,
    backgroundColor: `${GRAY_DISABLED}`,
    opacity: '1!important',
    transition: 'background-color 0.3s, border 0.3s',
  },
  optionsMenu: {
    boxShadow: `${OPTIONS_MENU_SHADOW}`,
  },
  modalParagraph: {
    marginBottom: '16px',
  },
  confirmationParagraph: {
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      color: `${RED_USC}`,
      marginRight: '5px',
      width: '20px',
    },
  },
}));
